import React from 'react';

import {
  useExternalJobBoardsState,
  useExternalJobBoardsActions
} from './ExternalJobBoardsContext';

import {
  getExternalJobBoards,
} from './restApi';

import PageController from '../../Shared/UI/PageController/components/PageController';

const ExternalJobBoardsPageController = () => {
  const externalJobBoardsState = useExternalJobBoardsState();
  const { onResponse, onError } = useExternalJobBoardsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  return (
    <PageController
      pageNumber={externalJobBoardsState?.pageNumber}
      numberOfPages={externalJobBoardsState?.numberOfPages}
      goToFirstPage={() => {
        getExternalJobBoards({
          onResponse,
          onError,
          body: {
            authenticityToken,
            pageNumber: 1,
            filterOptions: externalJobBoardsState?.filterOptions,
          },
        });
      }}
      goToPreviousPage={() => {
        getExternalJobBoards({
          onResponse,
          onError,
          body: {
            authenticityToken,
            pageNumber: (externalJobBoardsState?.pageNumber - 1),
            filterOptions: externalJobBoardsState?.filterOptions,
          },
        });
      }}
      goToNextPage={() => {
        getExternalJobBoards({
          onResponse,
          onError,
          body: {
            authenticityToken,
            pageNumber: (externalJobBoardsState?.pageNumber + 1),
            filterOptions: externalJobBoardsState?.filterOptions,
          },
        });
      }}
      goToLastPage={() => {
        getExternalJobBoards({
          onResponse,
          onError,
          body: {
            authenticityToken,
            pageNumber: externalJobBoardsState?.numberOfPages,
            filterOptions: externalJobBoardsState?.filterOptions,
          },
        });
      }}
    />
  );
};

export default ExternalJobBoardsPageController;
